import React from "react"
interface Props {
  size: number
}
const celebrationIconHref = "https://res.cloudinary.com/perkbox/image/upload/v1708438755/af9d0e1c-690a-4a43-81af-e425bea368dc.gif"
const CelebrationAnimated = (props: Props) => {
  const {size} = props
  return <img src={celebrationIconHref} width={size} height={size} {...props} />
}

export default CelebrationAnimated
